import { render, staticRenderFns } from "./TrendAnalysis.vue?vue&type=template&id=5d4ff80f&scoped=true"
import script from "./TrendAnalysis.vue?vue&type=script&lang=js"
export * from "./TrendAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TrendAnalysis.vue?vue&type=style&index=0&id=5d4ff80f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ff80f",
  null
  
)

export default component.exports